import { render, staticRenderFns } from "./school-index.vue?vue&type=template&id=7687c766&scoped=true&"
import script from "./school-index.vue?vue&type=script&lang=js&"
export * from "./school-index.vue?vue&type=script&lang=js&"
import style0 from "./school-index.vue?vue&type=style&index=0&id=7687c766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7687c766",
  null
  
)

export default component.exports